import { Component, Input, OnInit } from '@angular/core';
import { ScreeningService } from '../../services/screening.service';
import { AdverseActionLetterStats, ScreeningLight } from 'src/app/models/screeningInvite';
import { tap } from 'rxjs/internal/operators/tap';
import { ToastrService } from 'ngx-toastr';
import { FileDownloadService } from 'src/app/services/file-download.service';
import { FilteringService } from 'src/app/services/filtering.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-aal-manager',
  templateUrl: './aal-manager.component.html',
  styleUrls: ['./aal-manager.component.less']
})
export class AalManagerComponent implements OnInit {

  @Input() screeningToEdit: ScreeningLight;

  constructor(public screening: ScreeningService, public toast: ToastrService, public fileDownload: FileDownloadService, public filtering: FilteringService,
    public auth: AuthService) {
      
  }

  ngOnInit(): void {
   
  }

  public get showAALButtons() : boolean {
    //this isn't working for some reason -- investigate when we circle back on full refactoring
    // return this.screeningToEdit.showAALButtons;
    if(!this.screeningToEdit) return false;
		if(this.screeningToEdit.propertyDecision && (this.screeningToEdit.propertyDecision.toLowerCase() == 'decline' || this.screeningToEdit.propertyDecision.toLowerCase().includes('conditional')) && !this.screeningToEdit.screeningClosed) return true;
		return false;
  }

  downloadAdverseActionLetter() {
    this.screening.GenerateAdverseActionLetter(this.screeningToEdit.invitationId).pipe(
      tap(() => { this.toast.success('Generating Adverse Action Letter ...'); },
      err => { this.toast.error('Error downloading AAL!', '', { closeButton: true, disableTimeOut: true }) },
      () => {})
    ).subscribe();
      
  }

  downloadHistoricalAAL(aal : AdverseActionLetterStats) {
    this.toast.info(`Downloading Adverse Action Letter ...`);
    this.screening.DownloadArchivedAAL(aal.applicantDocumentId).subscribe((res : Blob) => {
      if(res) {
        this.fileDownload.HandleFileDownload(res, 'pdf', `Report ${this.screeningToEdit.invitationId} Adverse Action Letter.pdf`);
      } else {
        this.toast.error('Error downloading AAL!', '', { closeButton: true, disableTimeOut: true });
      }
    },
    error => {
      this.toast.error('Error downloading AAL!', '', { closeButton: true, disableTimeOut: true })
    });
  }

  sendAdverseActionLetter() {
    this.screening.SendAdverseActionLetter(this.screeningToEdit.invitationId).pipe(
      tap(() => { this.toast.success('Sending Adverse Action Letter ...'); },
      err => { this.toast.error('Error sending AAL!', '', { closeButton: true, disableTimeOut: true }) },
      () => {})
    ).subscribe();
  }

}
